import { jsx as m, jsxs as r } from "../../../_virtual/jsx-runtime.mjs";
import t from "react";
import { reoFormItemLabel as o, reoFormItemLabelContent as s } from "../css/ReoFormItem.mjs";
import l from "../../../depend/classnames/index.mjs";
const f = (e) => {
  const a = t.useMemo(() => l(
    o,
    "reo-basic-form-item-label-wrap",
    e.className
  ), [e.className]);
  return e.label ? /* @__PURE__ */ m("div", { className: a, children: /* @__PURE__ */ r(
    "label",
    {
      className: l(s, "reo-basic-form-item-label"),
      style: e.style,
      htmlFor: e.htmlFor,
      children: [
        e.label,
        e.colon ? ":" : null
      ]
    }
  ) }) : null;
};
export {
  f as default
};
//# sourceMappingURL=ItemLabel.mjs.map
